const UserFeatures = ({
    canAccessAnalytics = false,
    canAccessBilling = false,
    canAccessContacts = false,
    canAccessMainAccountSettings = false,
    canAccessMainAnalytics = false,
    canAccessMainContactSupport = false,
    canAccessMainContacts = false,
    canAccessMainHelp = false,
    canAccessMainMessages = false,
    canAccessMainMyProperties = false,
    canAccessMainNotificationCenter = false,
    canAccessMainResources = false,
    canAccessMainSecuritySettings = false,
    canAccessMessages = false,
    canAccessMultiFamilyResources = false,
    canAccessUserManagement = false,
    canAddListing = false,
    canRespondToReview = false,
    canUpdateListing = false,
    canAccessInvoicePayments = false,
} = {}) => ({
    canAccessAnalytics: Boolean(canAccessAnalytics),
    canAccessBilling: Boolean(canAccessBilling),
    canAccessContacts: Boolean(canAccessContacts),
    canAccessMainAccountSettings: Boolean(canAccessMainAccountSettings),
    canAccessMainAnalytics: Boolean(canAccessMainAnalytics),
    canAccessMainContactSupport: Boolean(canAccessMainContactSupport),
    canAccessMainContacts: Boolean(canAccessMainContacts),
    canAccessMainHelp: Boolean(canAccessMainHelp),
    canAccessMainMessages: Boolean(canAccessMainMessages),
    canAccessMainMyProperties: Boolean(canAccessMainMyProperties),
    canAccessMainNotificationCenter: Boolean(canAccessMainNotificationCenter),
    canAccessMainResources: Boolean(canAccessMainResources),
    canAccessMainSecuritySettings: Boolean(canAccessMainSecuritySettings),
    canAccessMessages: Boolean(canAccessMessages),
    canAccessMultiFamilyResources: Boolean(canAccessMultiFamilyResources),
    canAccessUserManagement: Boolean(canAccessUserManagement),
    canAddListing: Boolean(canAddListing),
    canRespondToReview: Boolean(canRespondToReview),
    canUpdateListing: Boolean(canUpdateListing),
    canAccessInvoicePayments: Boolean(canAccessInvoicePayments),
});

const User = ({
    firstName = '',
    lastName = '',
    userName = '',
    applicationsEnabled = false,
    paymentsAccessAllowed = false,
    loggedIn = false,
    isUserBlocked = false,
    hasStrongAuthentication = false,
    hasPaidForListing = false,
    impersonatorEmail = '',
    impersonatorUserToken = '',
    isSeattleHousingConnector = false,
    userToken = '',
    email = '',
    phoneNumber = '',
    roles = [],
    sessionSecondsRemaining = 1800,
    summary = {
        activeListingCount: 0,
        totalListingCount: 0,
    },
    isEmailVerified = false,
    isMultifamilyCustomer = false,
    isPostingPathAdmin = false,
    isRocketshipCustomer = false,
    isRocketshipCustomerOnly = false,
    isTwoFactorAuthEnabled = false,
    isTwoFactorAuthenticated = false,
    features = {},
    isMocked = false,
} = {}) => ({
    firstName: String(firstName),
    lastName: String(lastName),
    userName: String(userName),
    applicationsEnabled: Boolean(applicationsEnabled),
    paymentsAccessAllowed: Boolean(paymentsAccessAllowed),
    loggedIn: Boolean(loggedIn),
    isUserBlocked: Boolean(isUserBlocked),
    hasStrongAuthentication: Boolean(hasStrongAuthentication),
    hasPaidForListing: Boolean(hasPaidForListing),
    userToken: String(userToken),
    email: String(email),
    phoneNumber: String(phoneNumber),
    impersonatorEmail: String(impersonatorEmail),
    impersonatorUserToken: String(impersonatorUserToken),
    isSeattleHousingConnector: Boolean(isSeattleHousingConnector),
    roles,
    sessionSecondsRemaining: Number(sessionSecondsRemaining),
    summary: Object(summary),
    isEmailVerified: Boolean(isEmailVerified),
    isMultifamilyCustomer: Boolean(isMultifamilyCustomer),
    isPostingPathAdmin: Boolean(isPostingPathAdmin),
    isRocketshipCustomer: Boolean(isRocketshipCustomer),
    isRocketshipCustomerOnly: Boolean(isRocketshipCustomerOnly),
    isTwoFactorAuthEnabled: Boolean(isTwoFactorAuthEnabled),
    isTwoFactorAuthenticated: Boolean(isTwoFactorAuthenticated),
    features: UserFeatures(features),
    isMocked: Boolean(isMocked),
});

export default User;
